/**
 * ReportGroupEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { VisitEntity } from "../VisitEntity";
import { ReportEntity } from "../ReportEntity";
import { ReportGroupEntity } from "../ReportGroupEntity";
declare global {
    interface EntityTypeMap {
        ReportGroup: ReportGroupEntity;
    }
}
export abstract class ReportGroupGeneratedEntity extends BaseEntity {
    public abstract reportGroupId: string;
    public abstract date: Date | null;
    public abstract visitName: string | null;
    public abstract visitDate: Date | null;
    public abstract text: string | null;
    public abstract project: ProjectEntity;
    public abstract visit: VisitEntity | null;
    public abstract readonly reports: ReadonlyArray<ReportEntity>;
}
